module.exports = __webpack_public_path__ + "static/media/synth-awww.7a810ac6.mp3";